module.exports = __webpack_public_path__ + "assets/ic_heart-7f0836.svg";